import { render, staticRenderFns } from "./create-contact-action.vue?vue&type=template&id=783a5f22"
import script from "./create-contact-action.ts?vue&type=script&lang=js&external"
export * from "./create-contact-action.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports